export * from './console-adapter';
